/**
 * Applies persisted shadcn theme tokens (including `.dark`) as early as
 * possible so MUI dialogs/pages don't flash light mode on first paint.
 */
import React from 'react';
import { useThemeConfig } from '../../hooks/use-theme-config';

export const ThemeBootstrap: React.FC = () => {
  useThemeConfig();
  return null;
};
